import api from "./axiosInstance";

export const createManualPaymentApi = (data: {
  priceId: number;
  attendeeId: number;
}) => api.post("/manual-payment/create", data);

export const updateManualPaymentApi = (
  id: string,
  data: {
    priceId: number;
  }
) => api.patch(`/manual-payment/${id}`, data);

export const deleteManualPaymentApi = (id: string) =>
  api.delete(`/manual-payment/${id}`);

export const fetchPricesApi = (searchTerm?: string) => {
  const params = searchTerm ? { search: searchTerm } : {};
  return api.get("/admin/prices", { params });
};

export const fetchAvailablePricesApi = (classId: number, attendeeId: number) =>
  api.get(`/admin/prices/available/${classId}/${attendeeId}`);
